import { Customer, CustomerProfile } from './customer.model';
import { Region, RegionFormData } from './region.model';
import { Site, SiteFormData, SitesByRegion } from './site.model';
import { UserFormData, UserWithRelations } from './user.model';

export interface CustomerFormData {
  customer: Customer;
  customerProfile: CustomerProfile;
  
  regions: RegionFormData[];
  sites: SiteFormData[];
  adminUsers: UserFormData[];
  operatorUsers: UserFormData[];
  
  isEditMode: boolean;
  customerId?: number;
  currentStep?: number;
  hasUnsavedChanges: boolean;
  
  isValid: boolean;
  validationErrors: ValidationErrors;
}

export interface ValidationErrors {
  customer?: { [key: string]: string };
  customerProfile?: { [key: string]: string };
  regions?: { [index: number]: { [key: string]: string } };
  sites?: { [index: number]: { [key: string]: string } };
  adminUsers?: { [index: number]: { [key: string]: string } };
  operatorUsers?: { [index: number]: { [key: string]: string } };
  general?: string[];
}

export interface StepValidation {
  stepNumber: number;
  stepName: string;
  isValid: boolean;
  isComplete: boolean;
  errors: string[];
}

export enum FormStep {
  CUSTOMER_INFO = 1,
  REGIONS = 2,
  SITES = 3,
  USERS = 4
}

export enum FormMode {
  CREATE = 'create',
  EDIT = 'edit',
  VIEW = 'view'
}

export interface FormUIState {
  currentStep: FormStep;
  completedSteps: FormStep[];
  isLoading: boolean;
  isSubmitting: boolean;
  showValidationErrors: boolean;
  activeTabIndex: number;
}

export interface CustomerDataForAPI {
  customer: {
    name: string;
    contactNo: string;
    email: string;
    gstNo?: string;
    panNo?: string;
    uuid?: string;
    customer_profile_id?: number;
  };
  customerProfile: {
    name: string;
  };
  regions: Array<{
    name: string;
    sites: Array<{ name: string }>;
  }>;
  users: Array<{
    username: string;
    password: string;
    userDetails: {
      name: string;
      email?: string;
      mobile?: string;
    };
    roleNames: string[];
    regionNames: string[];
    siteNames: string[];
  }>;
}

export interface CompleteCustomerData {
  customer: Customer;
  customerProfile: CustomerProfile;
  regions: Region[];
  sites: Site[];
  users: UserWithRelations[];
  sitesByRegion: SitesByRegion[];
}

export interface SelectOption {
  value: any;
  label: string;
  disabled?: boolean;
  data?: any; 
}

export interface MultiSelectOption extends SelectOption {
  selected: boolean;
  parentId?: number;
  parentLabel?: string;
}

export interface EntityChangeEvent<T = any> {
  action: 'add' | 'update' | 'delete';
  entity: T;
  index?: number;
  oldValue?: T;
}

export interface FormStateChangeEvent {
  step: FormStep;
  isValid: boolean;
  hasChanges: boolean;
  data: Partial<CustomerFormData>;
}

export const VALIDATION_RULES = {
  CUSTOMER_NAME: {
    required: true,
    minLength: 2,
    maxLength: 255
  },
  CONTACTNO: {
    required: true,
    pattern: /^[0-9+\-\s()]+$/
  },
  EMAIL: {
    required: true,
    pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
  },
  USERNAME: {
    required: true,
    minLength: 3,
    maxLength: 50,
    pattern: /^[a-zA-Z0-9_]+$/
  },
  PASSWORD: {
    required: true,
    minLength: 6,
    maxLength: 20
  },
  REGION_NAME: {
    required: true,
    minLength: 2,
    maxLength: 45
  },
  SITE_NAME: {
    required: true,
    minLength: 2,
    maxLength: 45
  },
  USER_NAME: {
    required: true,
    minLength: 2,
    maxLength: 100
  }
} as const;